'use client';

import * as React from 'react';
import { cx } from '@/lib/ui';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cx(
        'flex h-10 w-full rounded-aula-md border border-aula-border bg-white px-3 py-2 text-sm text-slate-900 shadow-aula-control',
        'placeholder:text-slate-400',
        'focus-visible:border-aula-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-aula-primary/20',
        'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500 disabled:opacity-70',
        'aria-[invalid=true]:border-aula-danger aria-[invalid=true]:ring-2 aria-[invalid=true]:ring-aula-danger/15',
        className
      )}
      {...props}
    />
  )
);

Input.displayName = 'Input';

export default Input;
